function i(e, n) {
  return e && n ? n - e < Date.now() : !1;
}
export {
  i as tokensWillExpireWithinThreshold
};
